import React from 'react'

const Fantasy = () => {
  return (
    <div>
        <div>
            <h3>Working with words</h3>
            <p className='question'>A. Match the following words with their definitions.</p>
            <p>a. snappy ------ irritable and inclined to speak sharply</p>
            <p>b. discretion ------ the ability to behave without causing embarrassment or attracting too much attention</p>
            <p>c. radiant ------ showing great happiness, love or health</p>
            <p>d. irresolute ------ not able to decide what to do</p>
            <p>e. brusque ------ using very few words and sounding rude</p>
            <p>f. fitful ------ a quiet period between times of activity</p>
            <p>g. harlequin ------ a humorous character in some traditional plays</p>
            <p>h. lull ------ happening only for short periods</p>
            <p>i. janitress ------ a lady whose job is to take care of a building such as a school or a block of flats</p>
            <p>j. speck ------ a very small spot</p>
            

        </div>
        <hr/>
      <div>
        <p className='question'>B. Consult a dictionary or search over the internet and write definitions of the following terminologies used in the stock market.</p>
        <br/>
        <p>a. <strong>liquidity: </strong>Liquidity refers to how quickly and easily an asset or security can be bought or sold in the market without affecting its price.</p>
        <br/>
        <p>b. <strong>IPO: </strong>IPO stands for Initial Public Offering. It is the process by which a private company offers its shares to the public for the first time and becomes a publicly traded company.</p>
        <br/>
        <p>c. <strong>NEPSE: </strong>NEPSE stands for Nepal Stock Exchange. It is the only stock exchange in Nepal where shares of publicly listed companies are traded.</p>
        <br/>
        <p>d. <strong>index: </strong>An index is a statistical measure that shows the overall performance of a group of selected stocks.</p>
        <br/>
        <p>e. <strong>portfolio: </strong>A portfolio is a collection of financial investments like stocks, bonds, mutual funds, or other assets held by an individual or institution.</p>
        <br/>
        <p>f. <strong>dividend: </strong>A dividend is the portion of a company's profit that is distributed to its shareholders, usually in cash or additional shares.</p>
        <br/>
        <p>g. <strong>turn over: </strong>Turnover refers to the total value or volume of shares traded on a stock exchange during a specific period.</p>
        <br/>
        <p>h. <strong>margin: </strong>Margin is the money an investor borrows from a broker to buy shares, with the investor paying only a portion upfront.</p>
      </div>
      <div>
        <hr/>
        <h3>Comprehension</h3>
        <p className='question'>A. Write 'T' for true statements, 'F' for false ones or 'NG' if the information is not given in the text.</p>
        <p>a. Harvey Maxwell was a stock broker. T</p>
        <p>b. He was not happy with his clerk, Pitcher. NG</p>
        <p>c. Miss Leslie had been married to Maxwell for a year. F</p>
        <p>d. Maxwell had hired a machine to work in his office. NG</p>
        <p>e. He had instructed Pitcher to get a new stenographer. T</p>
        <p>f. Miss Leslie was amazed by Maxwell's proposal. T</p>
        <p>g. She thought that he had probably gone mad. F</p>
        <p>h. She realized that he had been absent-minded due to his business. T</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Answer the following questions.</p>
        <p className='question'>a. How did Maxwell enter his office?</p>
        <p>= Maxwell entered his office quickly and energetically. He was with a young lady stenographer, and he greeted Pitcher by saying, "Good morning."</p>
        <p className='question'>b. Describe the physical appearance of the young lady.</p>
        <p>= The young lady was beautiful, but not in the usual way expected of a stenographer. She didn't wear any flashy jewelry like chains or bracelets, and she didn't look like someone who was going out for a fancy lunch. Her dress was simple and grey, but it fit her well and looked elegant and modest. She wore a neat black turban hat with a gold-green macaw feather in it. That morning, she looked softly beautiful and shyly glowing. Her eyes were bright, her cheeks had a natural blush, and she wore a happy expression with a touch of sweet memory in it.</p>
        <p className='question'>c. What changes did Pitcher notice in the young lady?</p>
        <p>= Pitcher noticed that the young lady was acting differently than usual that morning. Instead of going straight into her usual working room, she paused and seemed unsure in the outer office. At one point, she even moved closer to Maxwell's desk, just enough so that he would notice her. This behavior was unusual for her and caught Pitcher's attention.</p>

        <p className='question'>d. What was Pitcher's reply to the young lady concerning a new stenographer?</p>
        <p>= Pitcher told the young lady that Maxwell had already asked him to find a new stenographer. So, he had notified the agency the day before to send a few candidates that morning. However, none of them had arrived yet except her.</p>

        <p className='question'>e. What proposal did Maxwell make with Miss Leslie?</p>
        <p>= Maxwell proposed marriage to Miss Leslie. He expressed his feelings and asked her to marry him.</p>
        <p className='question'>f. How did she react to his proposal?</p>
        <p>= When Maxwell proposed, she behaved in a very unusual way. At first, she looked surprised and amazed. Then, tears started flowing from her eyes. After that, she smiled warmly and happily through her tears, and gently put one of her arms around Maxwell's neck.</p>
      </div>
      <div>
        <hr/>
        <h3>Critical thinking</h3>
        <p className='question'>a. What message does the writer want to give by presenting Maxwell as an extremely absent-minded person?</p>
        <p>= The writer presents Maxwell as very absent-minded to show that his mind is always busy with important thoughts and ideas. Although he might seem forgetful or distracted in small matters, this is because he is deeply focused on his work and creative plans. The message is that sometimes people who appear careless or lost in their thoughts are actually very intelligent and dedicated. It reminds us not to judge someone just by their outward behavior because their mind might be working hard on things that really matter. Maxwell's absent-mindedness shows the difference between everyday small details and bigger, more meaningful ideas.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>b. Imagine you are Miss Leslie. Write how you were troubled emotionally when your own husband came to you and made a marriage proposal.</p>
        <p>= When Maxwell, my own husband, came to me and proposed marriage, I felt a mix of emotions that I couldn't easily explain. At first, I was completely surprised and didn't know how to react. My heart raced, and tears came to my eyes without me even realizing why. I was touched deeply because, even though we had been close, I hadn't expected him to express his feelings so openly.
</p><p>
There was also a feeling of confusion inside me, part of me was overwhelmed by happiness, while another part was shy and unsure. But as I looked at him, I felt warmth and love growing in my heart. I realized that his proposal was a sign of how much he cared for me, and that made me feel special and loved. Despite the shock, I accepted his love gladly and felt hope for our future together.
</p><p>
This moment showed me that love can come quietly and unexpectedly, and sometimes, it's the most surprising things that touch our hearts the deepest.</p>
      </div>
      <div>
        <hr/>
        <h3>Grammar</h3>
        <p className='question'>Study the following sentences and underline the relative clauses.</p>
        <p >a. I snatched a minute <strong>when</strong> things had slackened a minute.</p>
        <p>b. Instead of going straight into the adjoining room, <strong>where</strong> her desk was, she lingered slightly irresolute in the outer office.</p>
        <p>c. She was beautiful in a way <strong>that</strong> was decidedly stenographic.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Fill in the blanks with suitable relative pronouns: who, which, that, whom, whose, where, why, how, what or when.</p>
        <p>a. There is a lady <strong>whose</strong> wallet has been stolen.</p>
        <p>b. Do you know the man <strong>who</strong> sold these glasses?</p>
        <p>c. The knife <strong>which</strong> you cut the bread with is very sharp.</p>
        <p>d. Why do you blame him for everything <strong>that</strong> goes wrong?</p>
        <p>e. A cemetery is a place <strong>where</strong> dead bodies are buried.</p>
        <p>f. This school is for those children <strong>whose</strong> mother tongue is not Nepali.</p>
        <p>g. I don't know the name of the person <strong>whom</strong> I spoke over the telephone.</p>
        <p>h. I came to Kathmandu on the day <strong>when</strong> the devastating earthquake took place.</p>
        <p>i. In the application form she wrote <strong>when</strong> she needed a good payment.</p>
        <p>j. The pilot explained <strong>why</strong> he made force landing on the road.</p>
      </div>
      <hr/>
     <div>
        <p className='question'>C. Join the following pairs of sentences using who, which, that, whose, whom, where, when or what.</p>
        <p>a. The building was destroyed in the fire. It has now been rebuilt.</p>
        <p>= The building that was destroyed in the fire has now been rebuilt.</p>
        <br/>
        <p>b. A new cricket stadium is being made in Chitwan. It can accommodate one hundred thousand people.</p>
        <p>= A new cricket stadium which is being made in Chitwan can accommodate one hundred thousand people.</p>
        <br/>
        <p>c. Shanghai is the most populated city in the world. I stayed there for five years.</p>
        <p>= Shanghai, where I stayed for five years, is the most populated city in the world.</p>
        <br/>
        <p>d. This is the man. I gave some money to him this morning.</p>
        <p>= This is the man to whom I gave some money this morning.</p>
        <br/>
        <p>e. Do know the man? His son was awarded in the school yesterday.</p>
        <p>= Do you know the man whose son was awarded in the school yesterday?</p>
        <br/>
        <p>f. His step-mother was not very kind to him. He had been staying with her.</p>
        <p>= His step-mother, with whom he had been staying, was not very kind to him.</p>
        <br/>
        <p>g. He can never forget Nakkhu Jail. He had spent 14 years there.</p>
        <p>=  He can never forget Nakkhu Jail, where he had spent 14 years.</p>
        <br/>
        <p>h. He showed me his new tab. He had paid a hundred thousand rupees for it.</p>
        <p>= He showed me his new tab, which he had paid a hundred thousand rupees for.</p>
        <br/>
        <p>i. Nelson Mandela joined ANC in 1930s. He was a student then.</p>
        <p>= Nelson Mandela joined ANC in the 1930s, when he was a student.</p>
        <br/>
        <p>j. She forgot to buy the things. Her mother had told to buy them.</p>
        <p>= She forgot to buy the things that her mother had told her to buy.</p>
     </div>
    </div>
  )
}

export default Fantasy
